/**
 * Content versions of the static data files. Empty while developing; scripts/build-cf.mjs fills
 * them with content hashes so the files can be cached for a year and still change on each deploy.
 */
export const V = {"meta":"0863698a26","khsdd":"54b002f39e","doan":"6d5cb9764f","poi":"d95e4254cd","gia":"ab0b7fb183","build":"1c14e8d","labels":"b95d9f76c891","qhv":"6d8c2353f31c"};
/** `url` with `?v=<version of key>` appended when the build knows one. */
export const vurl = (url, key) => (V[key] ? url + (url.includes('?') ? '&' : '?') + 'v=' + V[key] : url);
